import Dialog		from "dialog";
import html		from "../html/mydialog.html";
import css		from "../css/mydialog.css";

class MyDialog extends Dialog {
	constructor() {
		super();

		this.classList.add("designer");
		this.show();
	}
	buttonClose_click() {
		this.close();
	}
	get html() {
		return html;
	}
	get css() {
		return super.css+css;
	}
}

customElements.define("fulljs-mydialog", MyDialog);

export default MyDialog;